import {
  GET_PERSONAL_INFORMATIONS_REQUEST,
  GET_PERSONAL_INFORMATIONS_SUCCESS,
  GET_PERSONAL_INFORMATIONS_FAILURE,

  UPDATE_PERSONAL_INFORMATIONS_PHONE_REQUEST,
  UPDATE_PERSONAL_INFORMATIONS_PHONE_SUCCESS,
  UPDATE_PERSONAL_INFORMATIONS_PHONE_FAILURE,

  UPDATE_PERSONAL_INFORMATIONS_EMAIL_REQUEST,
  UPDATE_PERSONAL_INFORMATIONS_EMAIL_SUCCESS,
  UPDATE_PERSONAL_INFORMATIONS_EMAIL_FAILURE,

  UPDATE_PERSONAL_INFORMATIONS_CITY_REQUEST,
  UPDATE_PERSONAL_INFORMATIONS_CITY_SUCCESS,
  UPDATE_PERSONAL_INFORMATIONS_CITY_FAILURE,

  UPDATE_PERSONAL_INFORMATIONS_EMAIL_BY_OTP_REQUEST,
  UPDATE_PERSONAL_INFORMATIONS_EMAIL_BY_OTP_SUCCESS,
  UPDATE_PERSONAL_INFORMATIONS_EMAIL_BY_OTP_FAILURE,
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PERSONAL_INFORMATIONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_PERSONAL_INFORMATIONS_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case GET_PERSONAL_INFORMATIONS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case UPDATE_PERSONAL_INFORMATIONS_PHONE_REQUEST:
      return { ...state, isLoading: true, error: null };
    case UPDATE_PERSONAL_INFORMATIONS_PHONE_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case UPDATE_PERSONAL_INFORMATIONS_PHONE_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case UPDATE_PERSONAL_INFORMATIONS_EMAIL_REQUEST:
      return { ...state, isLoading: true, error: null };
    case UPDATE_PERSONAL_INFORMATIONS_EMAIL_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case UPDATE_PERSONAL_INFORMATIONS_EMAIL_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case UPDATE_PERSONAL_INFORMATIONS_EMAIL_BY_OTP_REQUEST:
      return { ...state, isLoading: true, error: null };
    case UPDATE_PERSONAL_INFORMATIONS_EMAIL_BY_OTP_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case UPDATE_PERSONAL_INFORMATIONS_EMAIL_BY_OTP_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case UPDATE_PERSONAL_INFORMATIONS_CITY_REQUEST:
      return { ...state, isLoading: true, error: null };
    case UPDATE_PERSONAL_INFORMATIONS_CITY_SUCCESS:
      return { ...state, data: { ...state.data, cityId: action.payload }, isLoading: false, error: null };
    case UPDATE_PERSONAL_INFORMATIONS_CITY_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
